export enum SidePanelModulEnum {
    NONE = -1,
    AppsMenu = 1,
    About = 2,
    Settings = 3,
}
